<script setup>
  import { ref, computed, onMounted, getCurrentInstance } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { usePageLoadingStore } from "../../../../../stores/pageLoading";
  import _ from 'lodash';
  import moment from "moment";
  import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
  import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
  import adminJobFairResumeService from '../../../services/jobfair/adminJobFairResumeService';
  import JobFairResumeDetailModal from '../../../../user/components/modal/jobFair/JobFairResumeDetailModal.vue';
  import mypageJobFairResumeService from '../../../../user/services/mypage/jobFair/mypageJobFairResumeService';
  import JobFairResumeOpenModal from '../../../../user/components/modal/jobFair/JobFairResumeOpenModal.vue';
  import JobFairStudentResumeTabApplicantListView from './JobFairStudentResumeTabApplicantListView.vue';

  const route = useRoute()
  const router = useRouter()
  const loadingStore = usePageLoadingStore()
  const { $pageListBoardNo, $majorGb, $toast, $interests, $yyyymmddHHmmss, alert, confirm } = getCurrentInstance().appContext.config.globalProperties;

  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(1);
  const totalCount = ref(0);
  const searchOpen = ref(true);
  const list = ref([]);

  const data_interests = ref([...$interests]); // 관심 카테고리

  const jobFairResumeModal = ref(null);

  // 검색
  const searchTypeRef = ref(null);
  const interestsListRef = ref(null);

  const isApplicationListView = ref(false);
  const selectedResume = ref({});
  const selectedFileYn = ref({});

  // 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색)
  const searchDurationTypeGroup = ref([
    { label:'모든 기간', value: 'all' },
    { label:'기간 검색', value: 'term' },
  ])

  const pageSizeGroup = ref([
    { label:"10개씩 보기", value: 10 },
    { label:"30개씩 보기", value: 30 },
    { label:"50개씩 보기", value: 50 },
    { label:"100개씩 보기", value: 100 },
  ])

  // text 검색. tab 마다 항목 다름.
  const searchTypeGroup = ref([
    { label:"이름", value: "name", placeholder: "이름을 입력해주세요."  },
    { label:"아이디", value: "id", placeholder: "아이디를 입력해주세요." },
    { label:"회원코드", value: "code", placeholder: "회원코드를 입력해주세요." },
  ]);

  // 검색 - searchType 셀렉트 박스 선택시
  const onSelectSearchTypeGroup = (option) => {
    searchInput.value.searchType = option.value;
  }

  const searchInputPlaceholder = computed(()=>{
    const option = _.find(searchTypeGroup.value, { value: searchInput.value.searchType });
    if(option) {
      return option.placeholder;
    } else {
      return '';
    }
  })

  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  }

  // 페이지당 개수 변경
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  const initSearchInputModel = {
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'name', // name 이름, id 아이디, code 회원코드
    searchInput: '',
  };

  // 검색 초기값 설정
  const searchInput = ref({...initSearchInputModel});

  const retrieveList = () => {
    const now = new Date();
    const startYmd = searchInput.value.startYmd ? searchInput.value.startYmd : moment(now).format('YYYYMMDD');
    const endYmd = searchInput.value.endYmd ? searchInput.value.endYmd : moment(new Date(now.setDate(now.getDate() + 30))).format('YYYYMMDD');

    const paramObj = {
      searchInterests: _.map(searchInput.value.searchInterests).join(','),
      startYmd: searchInput.value.searchDurationType === 'all' ? '' : startYmd,
      endYmd: searchInput.value.searchDurationType === 'all' ? '' : endYmd,
      searchType: searchInput.value.searchType,
      searchInput: searchInput.value.searchInput,
      pageNumber: currentPage.value,
      size: pageSize.value,
    };

    loadingStore.loading = true;
    adminJobFairResumeService.retrieveJobFairResumeListAdminPaging(paramObj)
      .then(async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;

          list.value = $pageListBoardNo(
            result.content,
            totalCount.value,
            pageSize.value,
            currentPage.value
          );
        }
      })
      .catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
      });
  };

  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  }

  const clearSearchInput = () => {
    searchInput.value = {
      ...initSearchInputModel,
    };
    interestsListRef.value?.initOptions();
    searchTypeRef.value?.initSelectedOption('corpName');
  }

  // 이력서 보기
  const onClickMyResume = async (resumeId) => {
    await jobFairResumeModal.value.show({
      resumeId: resumeId || selectedResume.value?.resumeId,
      showDeleteBtn: false,
    });
  }

  // 입사지원 수 클릭
  const onClickApplicantCnt = (resume) => {
    const resumeId = resume.resumeId
    const fileYn = resume.fileYn
    isApplicationListView.value = true;
    selectedResume.value = resumeId;
    selectedFileYn.value = fileYn;
  }
    
  // 인재정보 공개 여부
  const onClickChangeResOpenYn = async (resume, resOpenYn) => {
    // 기존에 오픈된 이력서 존재 여부 확인. true/false
    let resumeY = 'N';
    if(resOpenYn === 'Y') {
      const result = await mypageJobFairResumeService.retrieveResumeResOpenYn(resume.userCd);
      resumeY = result.data.result || 'N';
    }

    let ok = null;
    if(resumeY === 'Y') {
      ok = await confirm([
        "상시채용관 인재정보에 공개할 수 있는",
        "<span style='color:red;'>이력서는 1개만 가능</span>합니다.",
        "<br/>",
        "해당 이력서를 공개 하시겠습니까?",
        "<span style='color:red;'>나머지는 비공개 처리 됩니다.</span>"
      ], "인재정보 공개");
      if(!ok) {
        return;
      }
    }
    let resOpenYnName = resOpenYn === 'Y' ? '공개' : '비공개';
    if(ok === null) {
      if (resOpenYn === 'Y') {
        ok = await confirm([`해당 이력서를 ${resOpenYnName} 하시겠습니까?`], "인재정보 공개");
      } else {
        ok = await confirm([`해당 이력서를 ${resOpenYnName} 하시겠습니까?`], "예", "아니오");
      }
    }

    if (ok) {
      const paramObj = {
        resumeId: resume.resumeId,
        userId: resume.userCd,
        resOpenYn,
      };

      mypageJobFairResumeService.updateStatusResumeResOpenYn(paramObj)
        .then(async (res) => {
          loadingStore.loading = false;
          if (res.data.code.toLowerCase() === 'success') {
            alert(["선택한 이력서가", `상시채용관 인재정보에 ${resOpenYnName} 되었습니다.`]);
            retrieveList();
          } else {
            alert(["인재정보 공개 여부 변경이 정상적으로 이루어지지 않았습니다."]);
          }
        })
        .catch((error) => {
          loadingStore.loading = false;
          alert(["인재정보 공개 여부 변경이 정상적으로 이루어지지 않았습니다."]);
        });
    }
  }

  const openDetailInNewTab = (linkName, id = {}) => {
    const url = router.resolve({
      name: linkName,
      params: { id },
    }).href;

    window.open(url, '_blank');
  }

  onMounted(() => {
    retrieveList();
  })
</script>

<template>
  <div v-if="!isApplicationListView">
    <!-- s: 검색 -->
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
          <dd>
            <KSACheckBoxGroup
              ref="interestsListRef"
              className="mr-md"
              name="interestsList"
              v-model="searchInput.searchInterests"
              :options="data_interests"
            />
          </dd>
        </dl>
        <dl>
          <dt>등록일</dt>
          <dd class="text-box">
            <div class="grid">
              <template v-for="group in searchDurationTypeGroup" key="item.value" >
                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
              </template>
              <div style="display: inline-block;" v-if="searchInput.searchDurationType !== 'all'">
                <KSADatepickerTerms
                  :startDate="searchInput.startYmd"
                  :endDate="searchInput.endYmd"
                  @update:startDate="(value)=> searchInput.startYmd = value"
                  @update:endDate="(value)=> searchInput.endYmd = value"
                />
              </div>
            </div>
          </dd>
        </dl>
        <!-- name 이름, id 아이디, rTitle 이력서 제목 검색 -->
        <dl>
          <dt>
            <KSASelect ref="searchTypeRef" :options="searchTypeGroup" class="select" @selectOption="onSelectSearchTypeGroup"/>
          </dt>
          <dd>
            <KSAInput class="text-box" v-model="searchInput.searchInput" :placeholder="searchInputPlaceholder" />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <!-- e: 검색 -->
    <!-- s: 버튼영역 -->
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount)}}</span>개</p>
      <div>
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
      </div>
    </div>
    <!-- e: 버튼영역 -->
    <div class="table-form">
      <table class="horizontal">
        <tr>
          <th>NO</th>
          <th>회원코드</th>
          <th>이름</th>
          <th>아이디</th>
          <th>이력서 제목</th>
          <th>관심 카테고리</th>
          <th>전공계열(주전공)</th>
          <th>입사지원</th>
          <th>최근 수정일</th>
          <th>등록일</th>
          <th>인재정보 공개</th>
        </tr>
        <tr v-for="resume in list" :key="resume.resumeId || resume.boardNo">
          <td>{{ resume.boardNo }}</td>
          <td>{{ resume.userCd }}</td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', resume.userCd)">{{ resume.userName }}</span>
          </td>
          <td>{{ resume.userLoginId }}</td>
          <td class="text-overflow long-overflow">
            <span class="file blue" v-if="resume.fileYn === 'Y'" v-for="resumeAttaches in resume.resumeAttaches" :key="resumeAttaches.attachSeq || resumeAttaches.fileName" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
              {{ resumeAttaches.fileName }}
            </span>
            <span class="clickable blue" v-else @click="onClickMyResume(resume.resumeId)">
              {{ resume.title }}
            </span>
          </td>
          <td>
            <span v-if="resume.fileYn === 'Y'">-</span>
            <span v-else>{{ resume.interests }}</span>
          </td>
          <td>{{ $gbNameKR('MAJOR_GB', resume.majorGb) }}</td>
          <td class="clickable blue" @click="onClickApplicantCnt(resume)">{{ resume.applicantCnt }}</td>
          <td>
            <span v-if="resume.fileYn === 'Y'">-</span>
            <span v-else>{{ $yyyymmddHHmmss(resume.modifyDate) }}</span>
            </td>
          <td>{{ $yyyymmddHHmmss(resume.createDate) }}</td>
          <td>
            <span v-if="resume.resOpenYn === 'Y'">
              <img src="../../../../../assets/images/toggle_on.png" @click="onClickChangeResOpenYn(resume, 'N')" style="cursor:pointer;" />
            </span>
            <span v-else>
              <span v-if="resume.fileYn === 'Y'">
                -
              </span>
              <span v-else>
                <img src="../../../../../assets/images/toggle_off.png" @click="onClickChangeResOpenYn(resume, 'Y')" style="cursor:pointer;" />
              </span>
            </span>
          </td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        등록된 이력서가 없습니다.
      </div>
    </div>
    <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
    />
  </div>
  <div v-if="isApplicationListView">
    <JobFairStudentResumeTabApplicantListView
      :resume-id="selectedResume"
      :file-yn="selectedFileYn"
      @go-back="isApplicationListView = false;"
    />
  </div>
  <JobFairResumeDetailModal ref="jobFairResumeModal" /> <!-- 특별채용관 이력서 상세 -->
  <JobFairResumeOpenModal ref="jobFairResumeOpenModal" :showButtons="false"/> <!-- 텍스트 색상을 위한 디자인 팝업 -->
</template>

<style scoped>
</style>
